import { render, staticRenderFns } from "./TestimonialCycler.vue?vue&type=template&id=027e1250&scoped=true&"
import script from "./TestimonialCycler.vue?vue&type=script&lang=ts&"
export * from "./TestimonialCycler.vue?vue&type=script&lang=ts&"
import style0 from "./TestimonialCycler.vue?vue&type=style&index=0&id=027e1250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027e1250",
  null
  
)

export default component.exports